/**
 * Enum kiểu dữ liệu map với BE
 * ndquang1 25.10.2023
 */
export default {
  // / Hệ số
  Coefficient : 1,
  // /  Tỷ lệ (hiện tại ở phần lương khi ta nói đến tỷ lệ nghĩa là tỷ lệ %)
  PercentRate : 2,
  // / Số tiền
  ReceiptDeleted: 3,
  // / Số lượng
  Quanlity: 4,
  // /Số lượng theo tùy chọn số lượng của hệ thống
  QuanlitySystem:5,
  // /Kiểu chữ
  StringData: 6,
  // / Kiểu ngày tháng
  DateData: 7,
  // /Cột dạng hyperlink, drilldown đến chứng từ, báo cáo, ...
  Hyperlink: 8
};
